import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_439: DocMigration = {
  maxSchemaVersion: "0.0.439",
  description: "Handle the results of splitting unrelated categories into their own categories",
  // ROOF_TRUNCATION_HEIGHT_DIMENSIONS from ROOF_SLOPE_SYMBOL
  // ROOF_WIDTH_DIMENSIONS from ROOF_SLOPE_SYMBOL
  // ROOF_HORIZONTAL_PLACEMENT_DIMENSIONS from ROOF_DIM_ANNOTATION
  apply(json: any) {
    for (const viewTemplateId in json["viewTemplates"]) {
      const viewTemplate = json["viewTemplates"][viewTemplateId];
      for (const category of viewTemplate["categories"]) {
        if (category === "ROOF_SLOPE_SYMBOL") {
          viewTemplate["categories"].push("ROOF_TRUNCATION_HEIGHT_DIMENSIONS");
          viewTemplate["categories"].push("ROOF_WIDTH_DIMENSIONS");
        }
        if (category === "ROOF_DIM_ANNOTATION") {
          viewTemplate["categories"].push("ROOF_HORIZONTAL_PLACEMENT_DIMENSIONS");
        }
      }
    }

    for (const settingsId in json["settings"]) {
      const settings = json["settings"][settingsId];
      if (settings["showDormerWallFramingWidthDimensions"] && settings["showDormerWallFramingHeightDimensions"]) {
        settings["showDormerWallFramingDimensions"] = true;
      } else if (
        settings["showDormerWallFramingWidthDimensions"] === false &&
        settings["showDormerWallFramingHeightDimensions"] === false
      ) {
        settings["showDormerWallFramingDimensions"] = false;
      }
    }

    return json;
  },
};

export default migration_0_0_439;
